const normalizePlace = (place) => {
  const id = String(place?.id || "").trim();
  const name = String(place?.name || "").trim();
  const monthlyPrice = Number(place?.monthlyPrice);
  if (!id || !name || !Number.isFinite(monthlyPrice) || monthlyPrice < 0) return null;
  return { id, name, monthlyPrice };
};

export async function loadSubscriptionPlaces(apiUrl) {
  try {
    const res = await fetch(`${apiUrl}/api/public-subscriptions/places`, { cache: "no-store" });
    if (!res.ok) throw new Error("places request failed");
    const json = await res.json();
    const list = Array.isArray(json?.data) ? json.data : [];
    return list.map(normalizePlace).filter(Boolean);
  } catch (_) {
    return [];
  }
}
